import { Component, Input, ChangeDetectorRef, OnChanges, SimpleChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { ErrorLoggerService, NotificationService } from 'app/services';
import { TranslateService } from '@ngx-translate/core';
import { MapZonesService } from 'app/shared/components';
import { ZoneResponse } from '@key-telematics/fleet-api-client';
import { BaseComponent } from 'app/shared/components/base/base.component';
import { AnalyticsCellValue, AnalyticsSettings } from 'app/shared/components/analytics';
import { ChartSectionHandler } from '../../entities/shared/chart.section';
import { AnalyticsChartData } from 'app/shared/components/analytics/chart/chart.component';
import { Subscription } from 'rxjs';


@Component({
    selector: 'key-admin-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss'],
    providers: [MapZonesService],
    standalone: false
})
export class AdminChartComponent extends BaseComponent implements OnChanges, OnDestroy, AfterViewInit {

    @Input() entity: ZoneResponse;
    @Input() handler: ChartSectionHandler;

    @Input() visible = false;

    errorMessage: string;

    cellset: AnalyticsCellValue[][];
    settings: AnalyticsSettings;
    chartType: string;

    currentValue: string;
    diffValue: string;
    diffIcon: string;

    settingChangedSubscrition: Subscription;

    constructor(
        private error: ErrorLoggerService,
        private notify: NotificationService,
        public i18n: TranslateService,
        private ref: ChangeDetectorRef
    ) {
        super();
    }

    ngOnDestroy() {
        if (this.settingChangedSubscrition) {
            this.settingChangedSubscrition.unsubscribe();
        }
    }


    ngAfterViewInit() {
    }

    ngOnChanges(_changes: SimpleChanges) {
        if (this.handler && this.visible) {
            if (!this.settingChangedSubscrition) {
                this.settingChangedSubscrition = this.handler.onSettingsChanged.subscribe(() => this.load());
            }
            this.load();
        }
    }

    async load(): Promise<void> {
        try {
            this.cellset = null;
            this.errorMessage = null;
            if (this.entity) {
                const data = await this.handler.loadDataSet(this.entity);
                this.cellset = data.cellset;
                this.settings = data.settings;
                this.chartType = data.chartType;
                if (this.cellset === null) {
                    this.showError(this.i18n.instant('ADMIN.EDITORS.SHARED.CHART.ERRORS.NO_INFORMATION'));
                }

            } else {
                this.cellset = null;
            }
        } catch (err) {
            console.error(err);
            this.showError(this.i18n.instant('ADMIN.EDITORS.SHARED.CHART.ERRORS.UNEXPECTED_ERROR'));
        }
        this.ref.markForCheck();
    }

    showError(error: any) {
        this.error.trackException(error);
        this.errorMessage = error && this.notify.translateError(error);
        this.ref.markForCheck();

    }

    onChartLoaded(data: AnalyticsChartData) {
        this.currentValue = null;
        try {
            if (this.settings.graph.series.default.type === 'line') {
                const min = data.datasets[0].data[0].raw;
                const max = data.datasets[0].data[data.datasets[0].data.length - 1].raw;
                this.currentValue = max.toString();
                this.diffIcon = (max >= min) ? 'caret-up' : 'caret-down';
                this.diffValue = Math.abs(max - min).toString();
            }
        } catch { }

    }


}
